import { render, staticRenderFns } from "./QuickMoveInsMap.vue?vue&type=template&id=bda45748&"
import script from "./QuickMoveInsMap.vue?vue&type=script&lang=js&"
export * from "./QuickMoveInsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports